/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {getGameId, setLocalMusic} from './constant'
import {
  SPORTTAB,
  RoundStatus,
  WinType,
  RESULTSTATUS,
  RepeatFlag,
} from './interface'

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495909
export const greedy_sports_homepage = createAsyncThunk(
  '/live/game/greedy_sports_homepage',
  async (arg: {mode?: SPORTTAB}, store: any) => {
    const {deviceinfo, path} = store.getState().env
    const {tab} = store.getState().Animal_Horse?.config || {}
    const resp = await http.post(
      '/live/game/greedy_sports_homepage',
      {
        mode: tab,
        ...arg,
        ...deviceinfo,
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 下注 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495927
// status 1 下注成功 2 下注失败
export const greedy_sports_bet = createAsyncThunk(
  '/live/game/greedy_sports_bet',
  async (
    arg: {
      mode: SPORTTAB
      target_id?: number
      bet_coins?: number
      is_repeat?: boolean
    },
    store: any
  ) => {
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/game/greedy_sports_bet',
      {
        ...arg,
        ...deviceinfo,
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 结果接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=179495939
export const greedy_sports_result = createAsyncThunk(
  'greedy_sports_result',
  async (arg: {mode: SPORTTAB; round_no: string}, store: any) => {
    // 每次获取开奖结果的时候将之前的结果清空
    const {deviceinfo, path} = store.getState().env
    const resp = await http.post(
      '/live/game/greedy_sports_result',
      {
        config_id: getGameId(path),
        room_id: deviceinfo.h_web_room_id,
        ...arg,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface normal_target_res_type {
  target_id: number // 目标ID
  odds: number // 中奖赔率
  hot_topn: number // 热榜排名
  bet_amounts: number // 下注金额
  total_bet: number // 总下注金额
}

export interface round_res_type {
  round_no: string // 轮次唯一性ID
  target_id: number // 中奖标的ID
}

interface round_rank_type {
  zy_id: string // 用户ID
  name: string // 用户名称
  avatar: string // 用户头像
  rank_no: number // 排名
  coin_nums: number // 中奖金额
}

interface InitialStateType {
  // 本地控制
  config?: {
    tab: SPORTTAB
    isGuide?: boolean // 新手引导标志
    /** 每一时刻的引导进度，引导不存在时为 null */
    guideProgress?: number | null
    hasPreLoadedAct?: boolean // 前置加载引导标志
    isLoading?: boolean // 加载标志
    playMusic?: boolean // 播放音乐
    bet_num?: number // 下注金额
    bet_lock?: boolean // 下注控制
    auto_hold_spin?: boolean // 是否是自动hold_spin
    /** 足球射门动画进行中，与场景 shotInProgress 同步，用于禁用射门按钮 */
    shotInProgress?: boolean
  }
  // home接口信息
  home?: {
    config_id?: number // 配置ID
    round_bet_limit: number // 每轮最大下注金额
    round_no: string // 当前轮次唯一性ID
    day_round: number // 当前轮次/日
    coin_num: number // 金币余额
    today_win: number // 今日赢钱总数
    target_list: Array<normal_target_res_type> // 目标列表
    round_status: RoundStatus
    round_target: number // 本轮的中奖标的ID,
    status_expire: number // 当前状态的剩余时间: 秒数
    bet_prices: Array<number> // 单次可下注金额列表
    default_bet_price: number // 默认下注金额
    history_result: Array<round_res_type> // 历史结果列表
    ui_config?: any
    /** 重复下注状态码，见 RepeatFlag 枚举 */
    repeat_flag?: RepeatFlag
    betted?: boolean // 是否下注
    // 长链接 245下发信息
    // 开奖时 未开奖没有结果信息
    // config_id?: number // 配置ID
    // round_no: string // 当前轮次唯一性ID
    status?: RoundStatus // 当前状态:0:下注阶段; 30s 1:开奖中阶段; 4s 2:开奖结果展示阶段 6s
    // status_expire: number // 当前状态的剩余时间: 秒数
    normal_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    advanced_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    master_result?: {
      hit_target: number // 命中的目标ID
      is_shoot: boolean // 是否射门
      shoot_hits: Array<number> // 射门命中列表
    }
    rank_flag?: boolean // 榜单红点
  }
  // result接口信息
  result?: {
    round_no: string // 轮次唯一性ID
    status: RESULTSTATUS // 本轮结果状态: 0:未参与;1:参与但失败;2:参与并获胜
    bet_coins: number // 本轮下注总金额
    reward_coins: number // 本轮中奖金额
    round_target: number // 本轮中奖标的ID
    round_rank: Array<round_rank_type> // 本轮中奖金额top3
    is_shoot: boolean // 是否射门
    shoot_hits: Array<number> // 射门命中列表
    win_type: WinType // 赢取类型:1:普通奖 2:大奖（多个图标）
  }
  preResult?: {
    round_no: string // 轮次唯一性ID
    status: RESULTSTATUS // 本轮结果状态: 0:未参与;1:参与但失败;2:参与并获胜
    bet_coins: number // 本轮下注总金额
    reward_coins: number // 本轮中奖金额
    round_target: number // 本轮中奖标的ID
    round_rank: Array<round_rank_type> // 本轮中奖金额top3
    is_shoot: boolean // 是否射门
    shoot_hits: Array<number> // 射门命中列表
    win_type: WinType // 赢取类型:1:普通奖 2:大奖（多个图标）
  }
}
const initData = {
  // 本地控制
  config: {
    isGuide: false,
    guideProgress: null as number | null,
    hasPreLoadedAct: false,
    isLoading: true,
    playMusic: true,
    bet_num: 0,
    bet_lock: false,
    tab: SPORTTAB.Normal,
  },
  // home接口信息
  home: {
    default_bet_price: 500,
  },
  result: {},
}
const initialState: InitialStateType = {
  config: {
    tab: SPORTTAB.Normal,
    guideProgress: null,
  },
}

// =============== 长链接数据处理
const messageReducers = {
  // 更新长链接信息 handle245 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612536
  updateMessageInfo: (state, action) => {
    const {status} = action.payload
    const {target_list} = state.home || {}
    Object.assign(state.home, {
      ...action.payload,
      round_status: status,
      target_list:
        status === RoundStatus.Bet
          ? target_list?.map((ite) => {
              return {...ite, bet_amounts: 0, total_bet: 0, hot_topn: 0}
            })
          : target_list,
    })
  },
  // 长链接下注数据：仅用 new_target_list 的 hot_topn、total_bet 更新现有 target_list，不覆盖 odds、bet_amounts 等
  updateBetInfo: (state, action) => {
    const target_list = state?.home?.target_list
    if (!target_list?.length) return
    const tab = state.config?.tab || SPORTTAB.Normal
    const {normal_targets, advanced_targets, master_targets} =
      action.payload || {}
    const new_target_list =
      tab === SPORTTAB.Advanced
        ? advanced_targets
        : tab === SPORTTAB.Master
        ? master_targets
        : normal_targets
    if (!new_target_list?.length) return
    for (const item of target_list) {
      const newItem = new_target_list.find(
        (f) => f.target_id === item.target_id
      )
      item.hot_topn = newItem?.hot_topn ?? 0
      item.total_bet = newItem?.total_bet ?? 0
    }
  },
}

// ============== 功能设置型reducer
const configReducers = {
  // 改变重复下注标志
  changeRepeatFlag: (state, action) => {
    Object.assign(state.home, {
      repeat_flag: action.payload,
    })
  },
  // tab切换
  changeTab: (state, action) => {
    Object.assign(state.config, {
      tab: action.payload,
    })
  },
  // 前置流程完成标记
  finishedPreLoadedAct: (state) => {
    Object.assign(state.config, {
      hasPreLoadedAct: true,
    })
  },
  // 引擎加载完毕之后隐藏加载页面
  finishedLoading: (state) => {
    Object.assign(state.config, {
      isLoading: false,
    })
  },
  // 切换音效（并持久化到 storage）
  ChangePlayMusic: (state) => {
    const next = !state.config.playMusic
    Object.assign(state.config, {playMusic: next})
    setLocalMusic(next)
  },
  // 改变下注金额
  changeBet: (state, action) => {
    // 处于免费玩不能更改下注
    if (!state?.config?.bet_lock) {
      Object.assign(state.config, {
        bet_num: action.payload,
      })
    }
  },
  // 新手引导
  setGuide: (state, action) => {
    Object.assign(state.config, {
      isGuide: action.payload,
    })
  },
  // 每一时刻的引导进度，引导不存在时为 null
  setGuideProgress: (state, action: PayloadAction<number | null>) => {
    Object.assign(state.config, {
      guideProgress: action.payload,
    })
  },
  // 足球射门动画进行中（与 Phaser 场景 shotInProgress 同步）
  setShotInProgress: (state, action: PayloadAction<boolean>) => {
    Object.assign(state.config, {
      shotInProgress: action.payload,
    })
  },
}

export const GreedySportsSlice = createSlice({
  name: 'Animal_Horse',
  initialState,
  reducers: {
    ...messageReducers,
    ...configReducers,
    initData: (state, action) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(greedy_sports_homepage.fulfilled, (state, action) => {
      const {target_list} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      Object.assign(state.home, {
        ...action.payload,
        betted,
      })
    })
    builder.addCase(greedy_sports_bet.fulfilled, (state, action) => {
      const {target_list, status} = action.payload
      // 默认的是否下注 是否的
      let betted = false
      betted = target_list?.some((f) => f.bet_amounts > 0)
      if (status === RESULTSTATUS.success) {
        Object.assign(state.home, {
          ...action.payload,
          target_list: target_list || state?.home?.target_list,
          betted,
        })
      }
    })
    builder.addCase(greedy_sports_result.fulfilled, (state, action) => {
      Object.assign(state.result, {
        ...action.payload,
      })
    })
  },
})

export const GreedySportsActions = GreedySportsSlice.actions
export const useGreedySports = () => {
  return useSelector((state) => state.Animal_Horse)
}
export default GreedySportsSlice.reducer
